import axios from "axios";

axios.defaults.baseURL = "https://pdf-gen-1008304377773.asia-southeast2.run.app";
// axios.defaults.baseURL = "http://localhost:49420";

export const Report = async (data) => {
  const res = await axios.post("/patrol/report", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};
